// Pure duplicate-detection logic (section 5). No Firebase.
import { categoryForIssue } from '../constants';

const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;

const normMobile = (m) => String(m || '').replace(/\D/g, '').slice(-10);

/**
 * Find a possible duplicate of a new complaint among existing tickets.
 * Rule: same mobile within 7 days AND (same order OR same product OR same issue category).
 * @param {object} candidate  { mobile, orderId, productIds, issueType, createdAt? }
 * @param {object[]} existingTickets
 * @param {number} now
 * @returns {object|null} the matched ticket, or null
 */
export const findDuplicate = (candidate, existingTickets = [], now = Date.now()) => {
    const mobile = normMobile(candidate.mobile);
    if (!mobile) return null;
    const candCategory = categoryForIssue(candidate.issueType);
    const candProducts = new Set(candidate.productIds || []);

    for (const t of existingTickets) {
        if (!t || t.status === 'closed') continue;
        if (normMobile(t.mobile) !== mobile) continue;
        const created = t.createdAt || 0;
        if (now - created > SEVEN_DAYS) continue;

        const sameOrder = candidate.orderId && t.orderId && candidate.orderId === t.orderId;
        const sameProduct = (t.productIds || []).some(p => candProducts.has(p));
        const sameCategory = categoryForIssue(t.issueType) === candCategory;

        if (sameOrder || sameProduct || sameCategory) return t;
    }
    return null;
};

// How many non-closed tickets this mobile already has (repeat-customer signal).
export const countCustomerComplaints = (mobile, existingTickets = []) => {
    const m = normMobile(mobile);
    if (!m) return 0;
    return existingTickets.filter(t => normMobile(t.mobile) === m).length;
};

export const isRepeatComplaintCustomer = (mobile, existingTickets = []) =>
    countCustomerComplaints(mobile, existingTickets) >= 1;
